/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsGet } from "../funcs/skillsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetSkillResult } from "../models/components/getskillresult.js";
import {
  GetSkillRequest,
  GetSkillSecurity,
} from "../models/operations/getskill.js";
import { unwrapAsync } from "../types/fp.js";
export type SkillQueryData = GetSkillResult;

export function prefetchSkill(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetSkillRequest,
  security?: GetSkillSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSkillQuery(
  client$: GramCore,
  request: GetSkillRequest,
  security?: GetSkillSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SkillQueryData>;
} {
  return {
    queryKey: queryKeySkill({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function skillQueryFn(ctx): Promise<SkillQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySkill(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "get", parameters];
}
